import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import defer from 'lodash/defer';
export default {
  name: 'SmartBanner',
  props: {
    storeUrl: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      platform: '',
      showBan: false,
      mobile: false
    };
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    type: function type() {
      return {
        path: 'description',
        args: {
          x: this.platform
        }
      };
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.getUserAgent();
    this.mobile = this.isMobile();
    defer(function () {
      if (_this.platform) {
        _this.showBan = true;
      }
    });
  },
  methods: {
    metaIos: function metaIos() {
      var authorizedMarkets = ['FR', 'DE', 'ES', 'IT', 'UK', 'PT', 'LU', 'AT'];
      var mstore = {};

      if (authorizedMarkets.indexOf(this.locale.market) !== -1) {
        mstore = {
          name: 'apple-itunes-app',
          content: 'app-id=1425027693'
        };
      }

      return mstore;
    },
    tracking: function tracking() {
      return {
        data: {
          event_category: 'App_Innersense',
          event_action: 'Clic_Button',
          event_label: 'Android'
        }
      };
    }
  },
  head: function head() {
    return {
      meta: [{
        name: 'google-play-app',
        content: 'app-id=com.innersense.osmose.android.maisonsdumonde'
      }, this.metaIos()]
    };
  }
};